export default __webpack_public_path__ + "static/media/verified.2c544e22.svg";